import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MapComponent } from '../map/map.component';

@Component({
  selector: 'ten-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyDialogModule, MatIconModule, MapComponent, NgIf],
})
export class MapDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MapDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public onCrossClick() {
    this.dialogRef.close();
  }

  public ngOnInit() {
    this.cdr.detectChanges();
  }
}
